// This file is automatically generated. Do not edit it directly.
import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

// Retrieve Supabase URL and Anon Key from environment variables
const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  import.meta.env.VITE_AI_NEXUS_SUPABASE_URL ||
  'https://spnbfzfmzboqlnkuvewu.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_AI_NEXUS_SUPABASE_ANON_KEY;
const browserStorage = typeof localStorage === 'undefined' ? undefined : localStorage;

// In test mode, skip the module-level throw so tests that vi.mock() this
// module don't crash at import time. Any test that actually invokes Supabase
// methods without mocking will get a clear network/auth error instead.
const isTest = import.meta.env.MODE === 'test';

function createSupabaseClient(): SupabaseClient<Database> {
  if (!SUPABASE_URL && !isTest) {
    throw new Error(`VITE_SUPABASE_URL is not set. Please check your deployment environment variables.
    Expected: https://spnbfzfmzboqlnkuvewu.supabase.co
    Received: ${SUPABASE_URL}
    Environment: ${import.meta.env.MODE}`);
  }

  if (!SUPABASE_PUBLISHABLE_KEY) {
    if (!isTest) {
      throw new Error(`VITE_SUPABASE_ANON_KEY is not set. Please check your deployment environment variables.
    Available env keys: ${Object.keys(import.meta.env).filter(k => k.includes('SUPABASE')).join(', ') || 'none found'}
    Environment: ${import.meta.env.MODE}`);
    }
    // Test stub: createClient with a placeholder key so the module loads cleanly.
    // Tests that need real Supabase behaviour should vi.mock() this module.
    return createClient<Database>(
      SUPABASE_URL || 'http://localhost:54321',
      'test-placeholder-anon-key',
    );
  }

  return createClient<Database>(
    SUPABASE_URL,
    SUPABASE_PUBLISHABLE_KEY,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: browserStorage,
      },
    }
  );
}

export const supabase = createSupabaseClient();

// Google Calendar webhook URL (if needed in future)
// export const GOOGLE_CALENDAR_WEBHOOK_URL = `${SUPABASE_URL}/functions/v1/google-calendar-webhook`;
